import React, { useState, useEffect } from 'react';
import { getLayoutProps } from '@/utils/layout/layout';
import PageLayout from '@/components/PageLayout';
import Head from 'next/head';
import User from '@/store/user';
import DefaultProductImage from '../../../public/assets/wave-grocery/Empty-States-Default/DefaultProductImage.png';

/* Controllers */
import { getOrFetchFooterData } from '@/utils/footerCalls';

import styles from '@/styles/Corporate.module.css';
import FullPageCart from '@/components/FullPageCart/FullPageCart';
export default function Cart({ cart, responsiveLogo, sliderProducts, emptyStates }) {
  const [user, setUser] = useState();
  const defaultProdImg = emptyStates?.default_product_image?.url || DefaultProductImage.src;

  useEffect(() => {
    const user$ = User.subscribe(_user => {
      setUser(_user);
    });
    return () => user$.unsubscribe();
  }, []);

  return (
    <>
      <Head>
        <title>{process.env.displayName}</title>
        <meta name="description" content={`App for ${process.env.displayName} by Wave Grocery`} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href={responsiveLogo} />
      </Head>

      <main className={styles.mainContainer}>
        <div className={styles.categoriesContainer}>
          <FullPageCart
            cart={cart}
            sliderProducts={sliderProducts}
            listIcon={process.env.listIcon}
            defaultProductImage={defaultProdImg}
          ></FullPageCart>
        </div>
      </main>
    </>
  );
}

Cart.getLayout = function getLayout(page) {
  return <PageLayout>{page}</PageLayout>;
};

export async function getStaticProps({ locale }) {
  const layoutProps = await getLayoutProps({ headerProps: { selectedIndex: -1 } }, locale);
  const [{ data: cartBannerData }, { data: cartProductsData }] = await Promise.all([
    getOrFetchFooterData('cart_carousel_banner', locale),
    getOrFetchFooterData('cart_slider_products', locale),
  ]);

  const cart = cartBannerData.data[0] ? cartBannerData : [];
  const sliderProducts = cartProductsData?.data[0] ? cartProductsData : [];

  const messages = {
    common: (await import(`../../../prebuild-data/i18n/${locale}/common.json`)).default,
    full_page_cart: (await import(`../../../prebuild-data/i18n/${locale}/full_page_cart.json`)).default,
  };

  return {
    props: {
      ...layoutProps,
      cart,
      sliderProducts,
      messages,
    },
  };
}
